import { render, staticRenderFns } from "./AISub.vue?vue&type=template&id=a67fc7c8&"
import script from "./AISub.vue?vue&type=script&lang=ts&"
export * from "./AISub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports